import { named, withDependencies } from '@wix/thunderbolt-ioc'
import { LoggerSymbol, PageFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ILogger } from '@wix/thunderbolt-types'
import { BuilderComponentRegistrarSymbol, BuilderComponentResolverSymbol, name } from './symbols'
import type { BuilderComponentRegistrar, BuilderComponentResolver, IBuilderComponentPageConfig } from './types'

export const builderComponentWillMount = withDependencies(
	[named(PageFeatureConfigSymbol, name), BuilderComponentResolverSymbol, BuilderComponentRegistrarSymbol, LoggerSymbol],
	(
		{ compTypeToAllDescendants }: IBuilderComponentPageConfig,
		BuilderComponentResolver: BuilderComponentResolver,
		builderComponentsRegistrar: BuilderComponentRegistrar,
		logger: ILogger
	) => {
		return {
			componentTypes: ['Builder'],
			async componentWillMount({ builderType }: { builderType: string }) {
				const { componentId: builderComponentId, appDefinitionId } =
					BuilderComponentResolver.getBuilderComponentResources({
						builderType,
					})

				return logger.runAsyncAndReport(
					async () => {
						const { loadAndRegisterComponent } = builderComponentsRegistrar

						const loadAndFetchComponentPromise = loadAndRegisterComponent(
							builderType,
							false,
							compTypeToAllDescendants[builderType] || []
						)

						await Promise.all([loadAndFetchComponentPromise])
					},
					'builder',
					`${appDefinitionId}-${builderType}-${builderComponentId}-builder-loader`
				)
			},
		}
	}
)
